import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import DefaultButton from '../../../../global/default-button/default-button';
import { hasPermission } from '../../../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../../../api/roles.dao';

interface IPreviewKnovioArtifactButtonProps {
    hidden?: boolean;
    className?: string;
    onClick: () => void;
}

const PreviewKnovioArtifactButton: React.FC<IPreviewKnovioArtifactButtonProps> = ({hidden, className, onClick}): JSX.Element => {
    const previewBtnFormattedMessage = (
        <FormattedMessage
            id='oe.common.view'
            description='Button text'
            defaultMessage='Preview'
        />
    );
    const isKnovioPreviewPermitted = hasPermission(Permission.PREVIEW_KNOVIO_CONNECTION);
    const btnClassName = className ? `small-button ${className}` : 'small-button';
    return isKnovioPreviewPermitted && !hidden ? (
        <DefaultButton
            onClick={onClick}
            className={btnClassName}
            dataTestId='preview-artifact'
            text={previewBtnFormattedMessage}
        />
    ) : null;
};

export { PreviewKnovioArtifactButton, IPreviewKnovioArtifactButtonProps };
